import { useTranslation } from 'react-i18next';
import type { Citacao } from '@/lib/citacao';
import { useWhatsAppMediaUrl } from '@/hooks/useWhatsAppMediaUrl';

/**
 * Conteúdo de uma citação (autor + trecho). Para imagens mostra uma miniatura
 * (resolvida em signed URL); para documentos/áudio/vídeo mostra o rótulo; para
 * texto (ou imagem com legenda) mostra o texto. O container/box é do chamador.
 */
export function CitacaoBloco({ citacao }: { citacao: Citacao }) {
  const { t } = useTranslation();
  const isImg = citacao.tipoMedia === 'image' && !!citacao.mediaStoragePath;
  const { data: url } = useWhatsAppMediaUrl(citacao.mediaStoragePath, isImg);

  const ehChaveI18n = citacao.preview.startsWith('panel.');
  // Esconde o rótulo redundante ("📷 Foto") quando há miniatura.
  const mostrarTexto = !!citacao.preview && (!ehChaveI18n || !isImg);
  const textoPreview = ehChaveI18n ? t(citacao.preview) : citacao.preview;

  return (
    <div className="citacao-bloco">
      <div className="citacao-bloco__texto">
        <span className="citacao-bloco__autor">{citacao.autor}</span>
        {mostrarTexto && <span className="citacao-bloco__preview">{textoPreview}</span>}
      </div>
      {isImg && url && <img src={url} alt="" className="citacao-bloco__thumb" />}
    </div>
  );
}
